import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import StyledGriddle from '../../../components/StyledGriddle';
import Griddle from 'griddle-react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
  Row,
  Col
} from 'react-bootstrap';

function findById(value) {
  return value.id === Number(this);
}

function findId(value) {
  return value == Number(this);
}


class BidHotelContacts extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			name: '',
			email: '',
			showValidationError: false,
			errorText: '',
			checkedContacts: [],
			contactData: this.props.bid.hotel.contacts,
			update:false,
			HotelContact:null,
			disable:true,
		}
		this.onNameChange = this.onNameChange.bind(this);
   		this.onEmailChange = this.onEmailChange.bind(this);
   		this.handleAddContact = this.handleAddContact.bind(this);
   		this.changeCheckBox = this.changeCheckBox.bind(this);
   		this.matchTour = this.matchTour.bind(this);
   		this.EditHotelContact = this.EditHotelContact.bind(this);
   		this.DeleteHotelContact= this.DeleteHotelContact.bind(this);
   		this.UpdateAddContact = this.UpdateAddContact.bind(this);
	}

	findContact(id) {
	    if (!this.props.bid) {
	      return {};
	    }
	    const idx = this.props.bid.hotel.contacts.findIndex(findById, id);
	    if (idx === -1) {
	      console.log('Unable to find bid: ', id);
	      return { id };
	    }
	    return this.props.bid.hotel.contacts[idx];
  }

	handleAddContact() {
		if(this.state.name.trim() == '') {
			this.setState({showValidationError: true, errorText: 'Please provide a name'})
			return
		}else if(this.state.email.trim() == '') {
			this.setState({showValidationError: true, errorText: 'Please provide the email'})
			return
		}else if(this.state.email != '' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) {
			this.setState({showValidationError: true, errorText: 'Please provide the valid email address'})
			return
		}
		this.setState({showValidationError: false})
		const payload = {name: this.state.name, email: this.state.email, is_rebid: false};
		this.props.addHotelContact(this.props.bid.id,payload,(response)=>{
			this.setState({
				contactData:response.hotel.contacts,
				name: '',
				email: '',
			});
		});
	}
	onNameChange(event) {
    	this.setState({ 
    		name: event.target.value,
    		disable:false, 
    	});
    }
    onEmailChange(event) {
    	this.setState({ 
    		email: event.target.value,
    		disable:false,
    	});
    }
    changeCheckBox(e) {
    	const id =  e.target.value;
    	const contact = this.findContact(id);
        const contactData = {'bid_id': this.props.bid.id, 'id': contact.id, 'email': contact.email, 'name': contact.username}
        let checkedContactList = this.state.checkedContacts;
        if(e.target.checked){
        	checkedContactList.push(id);
        }else if(e.target.checked == false){
        	const idx = checkedContactList.findIndex(findId, id);
        	checkedContactList.splice(idx, 1);
        }
        this.setState({
        	checkedContacts: checkedContactList
        })

        this.props.handleContactData(contactData, e.target.checked)
    }
    
    matchTour(contact){
    	if(!contact.is_sent){
    		return false
    	}else{
    		return contact.sent_tour_ids.includes(this.props.proposal.tour.id)
    	}
    }
    UpdateAddContact(){
    	let contact = this.state.HotelContact;
    	let bidId = this.props.bid.id;
    	let hotelId = this.props.bid.hotel.id;
    	let id = contact.id;
    	const payload = {'id':id,'hotel':hotelId,'newname':this.state.name,'newemail':this.state.email}
    	this.props.HotelContactUpdate(bidId,payload,(response)=>{
    		if(response.hotel.contacts.length!=0){
				this.setState({contactData:response.hotel.contacts})
			}
    		this.setState({
    			name:'',
    			email:'',
    			disable:true,
    			update:false,
    		})
    	})
    }

    EditHotelContact(contact){
    	let email = contact.email;
    	let name = contact.first_name+'  '+contact.last_name;
    	this.setState({
    		email:email,
    		name:name,
    		update:true,
    		HotelContact:contact,
    	})
    }
    DeleteHotelContact(id){
    	let bidId = this.props.bid.id;
    	let hotelId = this.props.bid.hotel.id;
    	this.props.HotelContactDelete(bidId,{'id':id,'hotel':hotelId},(response)=>{
			this.setState({contactData:response.hotel.contacts})
    	})

    }
	render() {
		const hotelContacts = [];
		const checkedContacts = this.state.checkedContacts;
		this.state.contactData.forEach(contact => {
			let id = contact.id;
			const isChecked = checkedContacts.includes(String(contact.id)) ? true : false ;
			hotelContacts.push(
				<div className="bid-hotel-contact">
					<input type='checkbox' value={id} checked={isChecked} onChange={(e) => this.changeCheckBox(e)}/>&nbsp;&nbsp;{contact.email}
					&nbsp;{contact.is_sent && this.matchTour(contact) && (<i className="fa fa-check bid-request-sent-icon" aria-hidden="true"></i>)}
					&nbsp;&nbsp;
					<span onClick={() => this.EditHotelContact(contact)} style={{ color: 'green',cursor:'pointer'}}>
						<i className="fa fa-pencil fa-lg"/>
					</span>&nbsp;&nbsp;
					<span onClick={()=>this.DeleteHotelContact(id)} style={{ color: 'green',cursor:'pointer'}}>
						<i  className="fa fa-remove fa-lg"/>
					</span>
				</div>
			)
		})

		return(
			<div>
				{hotelContacts}
				<p>or add:</p>
				<form method="post">
		            Name:
		            <input
		              name="name"
		              className="name request-from-hotel-input-fields"
		              type="text"
		              onChange={this.onNameChange}
		              value={this.state.name}
		            />
		            Email:
		            <input
		              name="email"
		              className="email request-from-hotel-input-fields"
		              type="text"
		              onChange={this.onEmailChange}
		              value={this.state.email}
		            />&nbsp;&nbsp;
					{this.state.update?(<Button bsStyle="info" disabled={this.state.disable} onClick={this.UpdateAddContact}>
					 Update
					</Button>
					):(<Button bsStyle="info" onClick={this.handleAddContact}>
					 Add
					</Button>)}
					{this.state.showValidationError && (<p className="alert alert-danger">{this.state.errorText}</p>)}
	           </form>
			</div>
		)
	}
};
BidHotelContacts.propTypes = {
  updateMergeValue: PropTypes.func.isRequired,
  mergedContacts: PropTypes.func.isRequired,
}

export default BidHotelContacts;


// WEBPACK FOOTER //
// src/routes/tours/components/BidHotelContacts.js